<template>
	<div class="menus-filter-container" :class="{hidden: menus.length === 0}">
		<div class="menu" :class="{active: activeMenu === menu.menu_id}" v-for="menu in menus" :key="menu.menu_id" @click="toggleMenu(menu)">
			<p>{{ menuDisplayName( menu.name ) }}</p>
		</div>
	</div>
</template>

<script>
import {useMenuStore, } from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";

export default {
	setup() {
		const menuStore = useMenuStore();
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {menuStore, getString: languageStore.getString, userStore, notificationStore};
	},
	name: "MenusFilter",
	emits: ["select-menu"],
	props: {
		menus: {type: Array, required: true},
		selectedMenu: {type: Number, default: null},
	},
	data() {
		return {
			activeMenu: null,
		}
	},
	methods: {
		toggleMenu(menu) {
			if (this.activeMenu !== menu.menu_id) {
				this.activeMenu = Number(menu.menu_id);
			}
			this.$emit("select-menu", this.activeMenu);
		},
		menuDisplayName( name ) {
			return ( name && name !== "" ? name : this.getString('no_name_cat') );
		},
	},
	mounted() {
		if(this.menus.length > 0 && this.activeMenu === null) {
			this.activeMenu = Number(this.menus[0].menu_id);
		}
	},
	watch: {
		menus: {
			handler() {
				if(this.menus.length > 0 && this.activeMenu === null) {
					this.activeMenu = Number(this.menus[0].menu_id);
				}
			},
			immediate: true,
		},
		selectedMenu: {
			handler() {
				if(this.selectedMenu !== null) {
					this.activeMenu = this.selectedMenu;
				}
			},
			immediate: true,
		},
	},
}
</script>

<style lang="scss" scoped>
.menus-filter-container {
	border-radius: 13px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 12px;
	gap: 12px;
	width: 100%;

	.menu {
		border-radius: 13px;
		border: 1px solid var(--color-primary);
		padding: 0 12px;
		cursor: pointer;
		user-select: none;
		transition: background-color 0.3s ease;
		height: 54px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		min-width: 140px;
		max-width: 250px;

		@media (max-width: 950px) {
			min-width: 120px;
		}

		@media (max-width: 850px) {
			min-width: 100px;
		}

		@media (max-width: 750px) {
			min-width: 120px;
		}

		@media (max-width: 550px) {
			min-width: 100px;
		}

		p {
			@include truncateString(1);
			font-size: 16px;
			color: var(--color-primary);
		}

		&.active {
			background-color: var(--color-active-button);
			p {
				color: var(--color-active-button-text);
			}
		}
	}

	@media (max-width: 900px) {
		padding: 8px;
		gap: 8px;

		.menu {
			padding: 0 8px;
		}
	}

}
</style>